import Vue from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import * as icons from './font-awesome-icons'

library.add(Object.values(icons))
Vue.component('font-awesome-icon', FontAwesomeIcon)
